// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__36COI","unreadBadge":"styles_unreadBadge__3-67T","modalContent":"styles_modalContent__3b1WL","modal":"styles_modal__37-ri"};